import store from '@/data/store'

// 获取特定字典表分类列表
export function getDictionary (category) {
  return new Promise((resolve, reject) => {
    let _category = store.getters.dictionary[category]
    if (_category && _category.length) {
      resolve(_category)
    } else {
      store.dispatch('setCategory', category).then(() => {
        resolve(store.getters.dictionary[category])
      }).catch(e => {
        reject(e)
      })
    }
  })
}

// 获取特定全部字典表分类列表
export function getAllDictionary () {
  return new Promise((resolve, reject) => {
    let _dictionary = store.getters.dictionary['dictionary']
    if (_dictionary && _dictionary.length) {
      resolve(_dictionary)
    } else {
      store.dispatch('setAllDictionary').then(() => {
        resolve(store.getters.dictionary['dictionary'])
      }).catch(e => {
        reject(e)
      })
    }
  })
}

// 获取特定字典翻译
function _findCanton (_d, _areaCode) {
  let _i
  _d.forEach(item => {
    if (item.areaCode === _areaCode) {
      _i = item.areaName
    } else if (item.children && item.children.length) {
      let _c = _findCanton(item.children, _areaCode)
      if (_c) {
        _i = _c
      }
    }
  })
  return _i
}
export function getNameFromAllDictionary (value, typeCode) {
  if (typeCode === 'province') {
    return _findCanton(store.getters.dictionary['canton'], value)
  } else {
    let _name = '-'
    const _dictionaryData = store.getters.dictionary['typeCodes']
    if (_dictionaryData && _dictionaryData.length) {
      _dictionaryData.forEach((item) => {
        if (item.typeCode === typeCode) {
          /* eslint-disable */
          if(item.value == value){
            _name = item.name
          }
        }
      })
    }
    return _name
  }
}
// 获取特定字典对象
export function getItemFromAllDictionary (value, typeCode) {
  let _item
  const _dictionaryData = store.getters.dictionary['typeCodes']
  if (_dictionaryData && _dictionaryData.length) {
    _dictionaryData.forEach((item) => {
      if (item.typeCode === typeCode) {
        /* eslint-disable */
        if(item.value == value){
          _item = item
        }
      }
    })
  }
  return _item
}

// 获取特定字典翻译
export function getDictionaryTypeList (typeCode) {
  if(store.getters.dictionary['typeCodes'].length){
    return store.getters.dictionary['typeCodes'].filter((item)=>{
      if(item.typeCode === typeCode){
        return true
      }else {
        return false
      }
    })
  } else {
    return []
  }
}


// WEBPACK FOOTER //
// ./src/common/utils/getDictionaryUtils.js